import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import isEmpty from "lodash.isempty";

import Layout from "layouts/Dashboard";
import authUtil from "utils/auth";
import alertUtil from "utils/alert";
import FourOThree from "pages/403";
import FiveHundred from "pages/500";
import { fetchAuthUser } from "actions/user";
import { toggleNotification, toggleconfirmationPopup } from "actions/toggle";

class AuthRoute extends Component {
  componentDidMount() {
    authUtil.isTokenValid() && this.props.fetchAuthUser();
  }

  checkAuthUserAuthorization() {
    if (!authUtil.isTokenValid()) {
      authUtil.removeToken();
      return;
    }
    const { data, loading, error } = this.props.authUser;
    if (error) {
      if (error.response && error.response.status === 403) {
        return "403";
      }
      return "500";
    }
    if (loading || isEmpty(data)) {
      return "loading";
    }
    if (!isEmpty(data)) {
      return "auth";
    }
    alertUtil.unexpectedError();
    authUtil.removeToken();
  }

  onClickNotificationDelete = () => {
    this.props.toggleNotification(false, {});
  };

  onClickConfirmationPopupCancel = () => {
    this.props.toggleconfirmationPopup(false, {});
  };

  AuthRouteComponent() {
    const {
      fullPageSpinnerActive,
      confirmationPopupActive,
      notificationActive,
      toggleNotification,
      className,
      authUser,
      ...rest
    } = this.props;

    return (
      <Layout
        match={this.props.computedMatch}
        authUser={authUser}
        className={className}
        fullPageSpinnerActive={fullPageSpinnerActive}
        confirmationPopupActive={confirmationPopupActive}
        notificationActive={notificationActive}
        onClickNotificationDelete={this.onClickNotificationDelete}
        onClickConfirmationPopupCancel={this.onClickConfirmationPopupCancel}
      >
        <Route {...rest} />
      </Layout>
    );
  }

  render() {
    switch (this.checkAuthUserAuthorization()) {
      case "403":
        return <FourOThree />;
      case "500":
        return <FiveHundred />;
      case "auth":
        return this.AuthRouteComponent();
      case "loading":
        return "is load";
      default:
        return (
          <Redirect
            to={{
              pathname: "/",
              state: { from: this.props.location }
            }}
          />
        );
    }
  }
}

export default connect(
  ({ authUser, fullPageSpinnerActive, confirmationPopupActive, notificationActive }) => ({
    authUser,
    fullPageSpinnerActive,
    confirmationPopupActive,
    notificationActive
  }),
  {
    fetchAuthUser,
    toggleNotification,
    toggleconfirmationPopup
  }
)(AuthRoute);



// WEBPACK FOOTER //
// ./src/routes/AuthRoute.js